import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../helpers';
import RootApp from './RootApp';
import { AppContextProvider } from '../../Services/AppContext';

loadDOMComponent({
	selector: 'react-app-root',
	callback: ({ container }) => {
		ReactDOM.render(
			<AppContextProvider>
				<RootApp />
			</AppContextProvider>,
			container,
		);
	},
});
